<template>
  <div id="ExhibitionPc">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner"></div>

      <div class="main2-content">
        <div class="layout-flex-title">
          <div class="title-btn" @click="handleBtnChange('store')">
            ID.STORE
          </div>
          <div class="title-btn active" @click="handleBtnChange('storep')">
            ID.3潮趣展
          </div>
        </div>
      </div>

      <!-- 列表车型 -->
      <div class="main2-content" style="padding-top: 11rem">
        <div
          class="layout-flex"
          v-for="(item, index) in workspace5"
          :key="index"
          :style="{ flexDirection: index % 2 ? 'row-reverse' : 'row' }"
        >
          <div
            class="layout-flex-1"
            :style="{ padding: index % 2 ? '0 0 0 11rem' : '0 11rem 0 0' }"
          >
            <div class="detail-title">{{ item.title }}</div>
            <div class="detail-content">{{ item.content }}</div>
            <div class="detail-btn" @click="handleDetail(item.url)"></div>
          </div>
          <div class="layout-flex-2">
            <div v-for="(item2, index2) in item.imgurl" :key="'z' + index2">
              <div v-if="index % 2 == 0">
                <div style="position: relative;">
                  <img :src="item2" style="width: 100%" />
                </div>
              </div>
              <div v-else>
                <div @click="handleVideo(index, index2)" style="position: relative;">
                  <img :src="item2" style="width: 100%" />
                  <img class="videoPlay" src="./components/play.png" />
                </div>
              </div>
            </div>
          </div>
          <el-carousel
            indicator-position="none"
            arrow="always"
            :autoplay="false"
            style="width: 100%; padding-top: 4rem"
            height="18rem"
            :initial-index="dialogIndex"
            ><el-carousel-item
              v-for="(item2, index2) in item.imgurl2Group"
              :key="index2"
            >
              <div class="layout-flex-carousel">
                <div
                  class="layout-flex-item"
                  v-for="(item3, index3) in item2"
                  :key="index3"
                  @click="handleImg2(index, index2 * 5 + index3)"
                >
                  <img v-if="item3" class="carousel-item-img" :src="item3" />
                </div>
              </div> </el-carousel-item
          ></el-carousel>
        </div>
      </div>

      <!-- 现场花絮 -->
    </div>

    <!-- 弹框图片 -->
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <el-carousel
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        style="width: 100%"
        height="82rem"
        :initial-index="dialogIndex"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 弹框视频播放 -->
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2">
      <contentVideo2 :url="dialogVideo"></contentVideo2>
    </el-dialog>
  </div>
</template>

<script>
import idPc from "@/views/id-store/idPc.vue";
import config from "./config";
export default {
  extends: idPc,
  data() {
    return {
      ...config,
    };
  },
};
</script>
<style lang="less" scoped>
@import "../id-store/pc.less";

//底纹
.main_bg {
  background: url("https://www.csvw.com//u/cms/www/202110/08183736n81z.png");
  background-size: 100% 100%;
}

// 轮播图
.layout-flex-carousel {
  display: flex;
  justify-content: space-between;
  .layout-flex-item {
    width: 30rem;
    height: 18rem;
    position: relative;
  }
  .carousel-item-img {
    width: 100%;
    height: 18rem;
  }
}
</style>